import BBHelperClass, { IActivityMatrix } from "../../classes/BBHelperClass";
import HelperClass from "../../classes/HelperClass";
import { PROD_VARIANT_CHOICES } from "../../components/Enumerators";
import { IBBApi, IBBParticipant } from "../../interfaces/IBB";

/* *******************************************************************************************************
 *
 * ******************************************************************************************************* */
const BBRegisterListElement = (props: { participant: IBBParticipant }) => {
    let toPay = HelperClass.calcBasket(props.participant.basket);
    let activityType = BBHelperClass.getParticipantActivityType(props.participant);

    function showTshirts() {
        let tshirts = BBHelperClass.getParticipantTShirtObjs(props.participant);
        return (
            <>
                {tshirts.map((basketProduct) => (
                    <span className="tag mr-2">
                        <i className="fa-solid fa-shirt mr-2"></i>
                        {basketProduct.prodDef?.variantType === PROD_VARIANT_CHOICES.PROD_VARIANT_TSHIRT_M ? "męska " : "damska "}
                        {basketProduct.inStore?.vName}
                        {basketProduct.cnt !== undefined && basketProduct.cnt > 1 && " x " + basketProduct.cnt}
                    </span>
                ))}
            </>
        );
    }

    return (
        <>
            <div className="list-item">
                {/* <div className="list-item-image">
                    <figure className="image is-64x64">
                        <img className="is-rounded" src="https://via.placeholder.com/128x128.png?text=Image" />
                    </figure>
                </div> */}

                <div className="list-item-content">
                    <div className="list-item-title">{props.participant.name}</div>
                    <div>
                        {activityType && (
                            <>
                                <span className="tag is-light mr-2">{BBHelperClass.getActivityName(activityType)}</span>
                            </>
                        )}
                        {/* <span className="tag is-light mr-2">Bieg</span>
                        <span className="tag is-light mr-2">Rower</span>
                        <span className="tag is-info mr-2">Iron Teacher</span> */}

                        <span className="tag is-size-7 mr-2">
                            klasyfikacja indywidualna:
                            <span className="ml-2">
                                <strong>{props.participant.rankConsent === true ? "TAK" : "NIE"}</strong>
                            </span>
                        </span>

                        {showTshirts()}
                        {/* <span className="mr-2">|</span> */}
                        {/* <span className="tag is-light mr-2">męska</span> */}
                    </div>
                    {/* <div className="list-item-description">List item description</div> */}
                </div>

                <div className="list-item-controls">
                    <div className="buttons is-right">
                        {/* <span>Do zapłaty</span> */}
                        {toPay > 0 && (
                            <div className="tag has-background-danger-light">
                                <span>do zapłaty: {toPay} zł</span>
                            </div>
                        )}
                        <button className="button">
                            <span className="icon is-small">
                                <i className="fas fa-edit"></i>
                            </span>
                            <span>Edytuj</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

/* *******************************************************************************************************
 *
 * ******************************************************************************************************* */
const BBRegisterList = (props: { bbApi?: IBBApi }) => {
    /* funkcja sortowania */

    if (props.bbApi === undefined) return <>PUSTO</>;
    //console.log(props.bbApi);

    let totalToPay = HelperClass.calcBaskets(props.bbApi.participants);

    return (
        <>
            Twoja lista startowa
            <div className="list has-visible-pointer-controls">
                {props.bbApi?.participants?.map((participant, index) => (
                    <BBRegisterListElement key={index} participant={participant} />
                ))}
                {totalToPay && (
                    <div className="list-item">
                        <div className="list-item-content"></div>
                        <div className="list-item-controls">
                            <div className="buttons is-right">
                                <div>
                                    <div className="is-size-7 has-text-right">
                                        razem: <span>{totalToPay}</span> zł
                                    </div>
                                    <div className="is-size-7 has-text-right">+ koszty wysyłki: 15 zł </div>
                                    <div>
                                        Razem do zapłaty: <span className="is-size-3">{totalToPay + 15}</span> zł
                                    </div>
                                </div>

                                <div className="ml-5 button has-background-success-light">Zapłać teraz</div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
export default BBRegisterList;
